export default function ($) {
  const burgerButton = window.document.querySelector('.c-hamburger');
  const menuParent = window.document.querySelectorAll('.navd .menu-parent');
  const menuChildren = window.document.querySelectorAll('.navd .menu-children');
  const menuImageSource = window.document.querySelectorAll('.navd .menu-link');
  const menuImageTarget = window.document.querySelectorAll('.navd .menu-image');
  const menuFooterLinks = document.querySelectorAll('.navd__nav--foot a');
  const navPropertyContainer = document?.querySelector('.navp__container');

  let ch = 0;

  /**
   * Reset
   * Remove all active classes
   *
   * @return void
   */
  function reset() {
    menuParent.forEach((item) => {
      item.classList.remove('current');
    });

    menuChildren.forEach((item) => {
      item.classList.remove('animate');
      setTimeout(() => {
        item.classList.remove('open');
      }, 100);
    });
  }

  /**
   * menuRollOfEffect
   *
   * @return void
   */
  function menuRollOfEffect() {
    const transition = window.document.querySelectorAll('.navd__col');

    if (!burgerButton.classList.contains('open')) {
      transition.forEach((item) => {
        setTimeout(() => {
          item.classList.add('animate');
        }, 70);
      });

      if (window.innerWidth >= 992 && navPropertyContainer !== null) {
        navPropertyContainer.style.visibility = 'hidden';
      }
    }
    if (burgerButton.classList.contains('open')) {
      transition.forEach((item) => {
        item.classList.remove('animate');
      });

      if (window.innerWidth >= 992 && navPropertyContainer !== null) {
        navPropertyContainer.removeAttribute('style');
      }
    }
  }

  /**
   * autoHeight
   * Adjust menu's container height
   *
   * @return void
   */
  function autoHeight() {
    const c = window.document.querySelectorAll('.navd__row');
    const n = window.document.querySelector('.navd__menu');
    const m = window.document.querySelector('.menu-children');
    if (n.clientHeight > ch) {
      ch = n.clientHeight + m.clientHeight + 40;
    }
    c.forEach((item) => {
      const cItem = item;
      cItem.style.height = `${ch}px`;
    });
  }

  /**
   * Tab init
   * Set first menu to active state
   *
   * @return void
   */
  function tabInit() {
    reset();

    const mp = window.document.querySelector('.menu-parent');
    if (!mp) {
      return;
    }
    const dp = mp.getAttribute('data-parent');
    const cn = window.document.getElementById(dp);

    mp.classList.add('current');

    if (!cn) {
      return;
    }

    setTimeout(() => {
      cn.classList.add('open');
      cn.classList.add('animate');
      autoHeight();
    }, 100);
  }

  /**
   * Menu image hydrate
   * Build the <img> from the data-menu-image attribute when the menu opens,
   * so the images are not in the page HTML for search engines
   *
   * @param el
   * @param highPriority - the image the user sees first: loaded eagerly with high priority,
   *                       all other images are lazy-loaded
   * @return void
   */
  function menuImageHydrate(el, highPriority = false) {
    if (!el || !el.dataset.menuImage) {
      return;
    }

    let data;
    try {
      data = JSON.parse(el.dataset.menuImage);
    } catch (e) {
      return;
    } finally {
      el.removeAttribute('data-menu-image');
    }

    if (!data.src) {
      return;
    }

    const img = document.createElement('img');
    img.className = 'navd__menu-image';
    img.alt = data.alt || '';
    img.decoding = 'async';
    if (highPriority) {
      img.fetchPriority = 'high';
    } else {
      img.loading = 'lazy';
    }
    if (data.width && data.height) {
      img.width = data.width;
      img.height = data.height;
    }
    if (data.srcset) {
      img.srcset = data.srcset;
      img.sizes = data.sizes || '';
    }
    img.src = data.src;

    el.prepend(img);
  }

  /**
   * Menu image first
   * First image of a group, or of the first group when no id is given
   *
   * @param id
   * @return {Element|null}
   */
  function menuImageFirst(id) {
    const group = id
      ? window.document.getElementById(id)
      : window.document.querySelector('.group-image');

    return group?.querySelector('.menu-image:first-child') ?? null;
  }

  /**
   * Menu image hide
   * Fade the items out, then hide them
   *
   * @param items
   * @return void
   */
  function menuImageHide(items) {
    $(items).stop(true).animate({ opacity: 0 }, 300, 'linear', function () {
      $(this).hide();
    });
  }

  /**
   * Menu image show
   * Fade the item in
   *
   * @param el
   * @return void
   */
  function menuImageShow(el) {
    // stop(true) also drops queued fade-outs, which would hide the item again
    $(el).stop(true).show().animate({ opacity: 1 }, 300, 'linear');
  }

  /**
   * Menu image init
   *
   * @param id
   * @return @void
   */
  function menuImageInit(id) {
    menuImageHide(menuImageTarget);
    menuImageShow(menuImageFirst(id));
  }

  /**
   * Tab change
   *
   * @param el
   */
  function tabChange(el) {
    reset();

    const dp = el.getAttribute('data-parent');
    const gi = el.getAttribute('data-group-image');
    const cn = window.document.getElementById(dp);

    menuImageInit(gi);

    el.classList.add('current');

    if (!cn) {
      return;
    }

    setTimeout(() => {
      cn.classList.add('open');
      cn.classList.add('animate');
      autoHeight();
    }, 100);
  }

  /**
   * Menu image change
   *
   * @param el
   * @return {boolean}
   */
  function menuImageChange(el) {
    const dg = el.getAttribute('data-group-image');
    const gi = window.document.getElementById(dg);

    if (!gi) {
      return false;
    }

    menuImageHide(menuImageTarget);
    menuImageShow(gi);
    return true;
  }

  menuParent.forEach((item) => {
    item.addEventListener('click', (event) => {
      if (!item.classList.contains('current')) {
        tabChange(event.target);
      }
    });
  });

  menuImageSource.forEach((item) => {
    item.addEventListener('mouseenter', (event) => {
      menuImageChange(event.target);
    });
  });

  burgerButton.addEventListener('click', () => {
    menuRollOfEffect();

    if (!burgerButton.classList.contains('open')) {
      // The first image of the first tab is shown right away, so it goes first
      menuImageHydrate(menuImageFirst(), true);
      menuImageTarget.forEach((item) => menuImageHydrate(item));
      tabInit();
      menuImageInit();
    }
  });

  function addAdaFocusLoopInsideMenu() {
    const lastMenuFooterLinkIndex = menuFooterLinks.length - 1;
    const lastMenuFooterLink = menuFooterLinks[lastMenuFooterLinkIndex];
    lastMenuFooterLink.addEventListener('focusout', () => {
      burgerButton.focus();
    });
  }

  window.addEventListener('resize', () => {
    tabInit();
  });

  window.addEventListener('load', () => {
    tabInit();
    addAdaFocusLoopInsideMenu();
  });
}
